import type {
  GetSettings200,
  GetSnapshotsKeySettings200,
} from '@ipfabric/api-client/client/schemas';
import type { SiteSeparation } from '@ipfabric/utils/schema/siteSeparation/siteSeparation';

type GeneratedSettingsData = GetSettings200 | GetSnapshotsKeySettings200;

export type SettingsData = GeneratedSettingsData & {
  // Necessary type augmentation,
  siteSeparation: SiteSeparation;
};

export const discoverySettingsAttributes = [
  'aim',
  'allowTelnet',
  'bgps',
  'cliRetryLimit',
  'cliSessionsLimit',
  'credentials',
  'customDiscoveryDefinitions',
  'disabledPostDiscoveryActions',
  'discoveryTasks',
  'fullBgpIpv6Limit',
  'fullBgpLimit',
  'limitDiscoveryTasks',
  'manualLinks',
  'networks',
  'ports',
  'privileges',
  'resolveNames',
  'seedList',
  'discoveryHistorySeeds',
  'scanner',
  'siteSeparation',
  'timeouts',
  'traceroute',
  'vendorApi',
] as const satisfies (keyof SettingsData)[];

/**
 * Discovery Settings as received from API
 */
export type DiscoverySettingsObject = Pick<
  SettingsData,
  (typeof discoverySettingsAttributes)[number]
>;
